/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ school: NonNullable<unknown> }} Planning_Vakanties_Regio_VraagInputs */

const nl_planning_vakanties_regio_vraag = /** @type {(inputs: Planning_Vakanties_Regio_VraagInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`In welke vakantieregio ligt ${i?.school}? Dan zetten we de schoolvakanties en feestdagen er meteen in.`)
};

/**

* @param {Planning_Vakanties_Regio_VraagInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_vakanties_regio_vraag = /** @type {((inputs: Planning_Vakanties_Regio_VraagInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Vakanties_Regio_VraagInputs, { locale?: "nl" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_vakanties_regio_vraag(inputs)
});
export { planning_vakanties_regio_vraag as "planning.vakanties.regio_vraag" }